import { Component, OnInit, HostListener, ViewEncapsulation, AfterViewInit, OnDestroy } from '@angular/core';
import { Utility } from '../shared/utility/utility';
import { AppDetailsService } from '.././services/app-details.services';
import { Router } from '@angular/router';
import { EmitterService } from '.././services/emitter.service';
import * as $ from 'jquery';
window['$'] = window['jQuery'] = $;
import { BannerService } from '../services/banner.service';
import { environment } from '../../environments/environment';
import { FormValidationComponent } from '../form-validation/form-validation.component';
import { CountryDataService } from '../services/country.service';
import { takeUntil } from "rxjs/operators";
import { Subject } from 'rxjs';

@Component({
  selector: 'app-banner',
  templateUrl: './html/app-banner.component.html',
  styleUrls: ['./sass/app-banner.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class BannerComponent extends FormValidationComponent implements OnInit, AfterViewInit, OnDestroy {
  yearRange = [];
  availableCountries: any;
  availableCurrency;
  ipCountry;
  isUserLoggedIn;
  windowType;
  banner_data: any;
  banners;
  imagePath;
  langCode;
  availableCountry;
  isCountryAllowed = 0;
  siteUrlPath: string = environment.siteUrl;
  private setdeposit = new Subject<String>();
  setdeposit$ = this.setdeposit.asObservable();
  destroy$: Subject<boolean> = new Subject<boolean>();

  constructor(
    private utils: Utility,
    private appDetails: AppDetailsService,
    private router: Router,
    private emitter: EmitterService,
    private bannerService: BannerService,
    private countryDataService: CountryDataService
  ) {
    super(utils);
    this.langCode = localStorage.getItem('langCode');
    this.emitter.langCodeSource$.pipe(takeUntil(this.destroy$)).subscribe(langCode=>{
      this.langCode = langCode;
    });
  }

  @HostListener('window:resize') onResize() {
    this.deviceType();

    /* PhoneNumberFlag dropdown list is not closing in
       mobile on orientation change */
    if($(".intl-tel-input.iti-container").length > 0) {
      $("body").trigger("click");
    }
  }

  ngOnInit() {
    this.loadbanner();
    this.emitter.loadHomeBanner$.pipe(takeUntil(this.destroy$)).subscribe(message=>{
        this.loadbanner();
      }
    );
    this.emitter.langCodeSource$.pipe(takeUntil(this.destroy$)).subscribe(message=>{
        if (localStorage.getItem("langCode") !== message) {
          this.loadbanner();
        }
      }
    );
  }

  ngAfterViewInit() {
    setTimeout(() => {
      this.deviceType();
    });
  }

  deviceType() {
    const ww = document.body.clientWidth;
    if (ww <= 767) {
      this.windowType = "mobile";
    } else {
      this.windowType = "desktop";
    }
  }

  initialstep() {
    this.isUserLoggedIn = this.utils.isUserLoggedIn();
  }

  loadbanner(bannerZoneID?: String) {
    let self = this;
    bannerZoneID = !bannerZoneID ? '1' : bannerZoneID;
    let bannerRequest = { 'zoneId': bannerZoneID };
    if (this.utils.getAffliateId('affiliate')) {
      bannerRequest["affiliateId"] = this.utils.getAffliateId('affiliate');
    }
    this.isCountryAllowed = 0;
    Promise.resolve(this.bannerService.getBanners(bannerRequest)).then(banners => {
      this.getCountry();
      if (banners && banners.length > 0) {
        let bannerLen = banners.length;
        let i = Math.floor(Math.random() * bannerLen);
        let bannersTest = banners[i];
        // _.each(bannersTest, function (banner) {
        bannersTest.content = bannersTest.content.replace(new RegExp('{{siteUrl}}', 'g'), environment.siteUrl);
        this.banners = bannersTest;
        // })
        setTimeout(() => {
          let bannersButtons = $('.cm-slider__btn--cta');
          // _.each(bannersButtons, function (buttons, index) {
            $(bannersButtons).data('target', this.banners.targetUrl);
          // })
          $(bannersButtons).on('click', function () {
            if ($(this).data("target") === "register") {
              self.router.navigate([self.langCode + '/register']);
            } else if ($(this).data("target") === "login") {
              self.router.navigate([self.langCode + '/login']);
            } else if ($(this).data("target") === "playnow") {
              self.router.navigate([self.langCode + '/login']);
            } else {
              self.router.navigate([self.langCode + $(this).data("target")]);
            }
          });
          if (this.windowType === 'desktop') {
            this.imagePath = this.banners["imagePath"];
          } else if (this.windowType === 'mobile') {
            this.imagePath = this.banners["mobileImage"];
          }
        }, 1);
      } else {
        banners = banners;
      }
      this.initialstep();
    });
  }

  movetopromotions() {
    this.router.navigate([this.langCode + '/']);
  }

  getCountry(country?: String) {
    if (environment.trustlyCountries.indexOf(this.countryDataService.ipCountry.toUpperCase()) >= 0) {
      this.isCountryAllowed = 1;
      this.appDetails.country = this.countryDataService.ipCountry;
    } else {
      this.isCountryAllowed = 2;
      this.appDetails.country = null;
    }
    // this.loadbanner();
    // Promise.resolve(this.bannerService.getCountry()).then(regData => {
    //   self.countryDataService.setData(regData["country"]);
    //   self.availableCountry = self.countryDataService.getCountries('blockedCountries');
    //   let isBroadcast = regData["broadcast"];
    //   regData = regData["country"];
    //   if (regData && regData["country"]) {
    //     isBroadcast ? this.userDetailsService.setUserCountry(regData['country']) : '';

    //   } else {
    //     isBroadcast ? this.userDetailsService.setUserCountry(null) : '';
    //   }

    // });
  }

  ngOnDestroy() {
    this.destroy$.next(true);
    this.destroy$.unsubscribe();
  }
}
